import type { AxiosResponse } from 'axios';
import pino from 'pino';
import type { ApiError, HttpResponseError } from './httpClient.interface';

/**
 * Nothing came back at all: the request timed out, the connection went, or it
 * was called off. Whatever it asked for may well have gone through on the other
 * side regardless, which is not the same thing as being turned down.
 */
export const NETWORK_ERROR_KEY = 'error_network';

export class HttpError {
  status: number;
  statusText: string;
  error: ApiError;

  constructor(response?: AxiosResponse) {
    if (response) {
      this.status = response.status;
      this.statusText = response.statusText;
      this.error = this.setError(response.data);
    } else {
      this.status = 400;
      this.statusText = 'Something went wrong.';
      this.error = { ...this.setError(), errorKey: NETWORK_ERROR_KEY };
    }
  }

  private setError(data?: HttpResponseError): ApiError {
    return {
      code: data?.code || this.status,
      message: data?.message || this.statusText,
      errorKey: data?.key || 'error_generic',
      unlocks: data?.unlocks,
      gambitId: data?.gambitId,
      distanceM: data?.distanceM,
      nextMoveAt: data?.nextMoveAt,
    };
  }
}

export const generalError = (): ApiError => {
  return {
    code: 400,
    message: 'Something went wrong.',
    errorKey: 'error_generic',
  };
};

export const HandleApiError = (e: unknown, logger: pino.Logger) => {
  const httpError = e as HttpError;
  logger.error(`${httpError.error?.code || 400} => ${httpError.error?.message || 'Server error'}`);
  throw httpError.error;
};
